import { render, staticRenderFns } from "./MMultiSelect.vue?vue&type=template&id=dfbf9260"
import script from "./MMultiSelect.vue?vue&type=script&lang=js"
export * from "./MMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./MMultiSelect.vue?vue&type=style&index=0&id=dfbf9260&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports